function getFromStorage(key: string) {
    const storedValue = localStorage.getItem(key);
    return !!storedValue && JSON.parse(storedValue);
}

function getFromStorageOrDefault<T>(key: string, defaultValue: T): T {
    const storedValue = localStorage.getItem(key);
    return storedValue ? (JSON.parse(storedValue) as T) : defaultValue;
}

function saveToStorage(key: string, value: unknown) {
    localStorage.setItem(key, JSON.stringify(value));
}

export const getUserMapLayers = function (area: string): { [layerId: string]: boolean } {
    return getFromStorage('mapLayers-' + area.toLowerCase());
};

export const setUserMapLayer = function (area: string, layerId: string, enabled: boolean): void {
    const storageKey = 'mapLayers-' + area.toLowerCase();
    const layers = getFromStorage(storageKey) || {};
    layers[layerId] = enabled;

    saveToStorage('mapLayers-' + area.toLowerCase(), layers);
};

/**
 * Renames a stored map-layer key while keeping its on/off value, so a persisted
 * selection survives a layer being replaced by a differently-named variant.
 * No-op when the source key is absent. When both keys already exist, the target
 * (correct) key is kept and the stale source is dropped without overwriting it.
 */
export const renameUserMapLayer = function (area: string, fromLayerId: string, toLayerId: string): void {
    if (fromLayerId === toLayerId) {
        return;
    }

    const storageKey = 'mapLayers-' + area.toLowerCase();
    const layers = getFromStorage(storageKey);
    if (!layers || !(fromLayerId in layers)) {
        return;
    }

    if (!(toLayerId in layers)) {
        layers[toLayerId] = layers[fromLayerId];
    }
    delete layers[fromLayerId];

    saveToStorage(storageKey, layers);
};

export const setUserProp = function (key: string, value: unknown): void {
    saveToStorage(key.toLowerCase(), value);
};

export const getUserProp = function (key: string) {
    return getFromStorage(key.toLowerCase());
};

export const getUserPropOrDefault = <T>(key: string, defaultValue?: T): T => {
    return getFromStorageOrDefault(key.toLowerCase(), defaultValue);
};
